import React, { Component } from 'react';
import Icon from 'components/Icon/Icon.react';
import styles from './Pulse.scss';


const Pulse = () => {
  return (
    <div className={[styles.pulse, styles.live].join(' ')}>
      <div className={styles.rings}></div>
    </div>
  );
}


export default Pulse